// src/slices/ads/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getAds } from "./thunk";

const initialState = { ads: [], loading: false, error: null };

const adsSlice = createSlice({
  name: "ads",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET ADS
      .addCase(getAds.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAds.fulfilled, (state, action) => {
        state.loading = false;
        state.ads = action.payload?.data || action.payload;
      })
      .addCase(getAds.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default adsSlice.reducer;
